/**
 * Reads the Quick Find `rovoJourneyId` straight off the current URL.
 *
 * Deliberately not `useQueryParams()`: that hook falls back to a `react-sweet-state` store when
 * `serveBootstrapProviderExp()` is false, and `search-page/AGENTS.md` forbids new RSS-backed
 * `src/controllers/store/**` dependencies inside `src/ui/search-page-relay/**`. The non-RSS
 * alternative, `useQueryParamsContext()`, is only populated behind that same experiment, so it would
 * read `undefined` for most users today.
 *
 * The param still belongs in the query-params schema and in each host's allow-list — those govern
 * whether the id survives being written to, and rebuilt from, the URL. This helper only covers
 * reading it back.
 */
export const getRovoJourneyIdFromUrl = (): string | undefined => {
	try {
		// `||`, not `??`: a present-but-empty param (`?rovoJourneyId=`) reads as `''`, which should be
		// treated as absent rather than passed downstream as an empty attribute.
		return new URLSearchParams(window.location.search).get('rovoJourneyId') || undefined;
	} catch {
		// No `window` (SSR) or an unparseable location. Nothing to attribute.
		return undefined;
	}
};
